import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app.routes';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { urlCleanerInterceptor } from './shared/interceptors/url-cleaner.interceptor';
import { idempotencyInterceptor } from './shared/interceptors/idempotency.interceptor';
import { trimInterceptor } from './shared/interceptors/trim.interceptor';
import { uploadInterceptor } from './shared/interceptors/upload.interceptor';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { tokenRefreshInterceptor } from './shared/interceptors/token-refresh.interceptor';
import { credentialsInterceptor } from './shared/interceptors/credentials.interceptor';
import { loaderInterceptor } from './shared/interceptors/loader.interceptor';
import { cacheBusterInterceptor } from './shared/interceptors/cache-buster.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withViewTransitions({
        onViewTransitionCreated: ({ transition }) => {
          transition.finished.then(() => {});
        },
      })
    ),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        loaderInterceptor,
        urlCleanerInterceptor,
        credentialsInterceptor,
        authInterceptor,
        tokenRefreshInterceptor,
        idempotencyInterceptor,
        trimInterceptor,
        uploadInterceptor,
        cacheBusterInterceptor
      ]),
    ),
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: {
        usePopover: false,
      },
    },
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 2000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      })
    ),
  ],
};
